import { NgModule, inject } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { DomSanitizer } from '@angular/platform-browser';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrSharedModule } from '@next/core-lib/shared';

import { MultipleSelectDialogComponent } from './components/multiple-select-dialog/multiple-select-dialog.component';

@NgModule({
  declarations: [
    // add shared components here
    MultipleSelectDialogComponent,
  ],
  imports: [
    AgrSharedModule,
    // added for multiple select dialog, move it to the component lib
    MatSelectModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    AgrDialogModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    AgrSharedModule,
    // add shared modules here
  ],
  providers: [
    // add shared services and guards here
    // ApiService,
  ],
})
export class SharedModule {
  constructor() {
    const matIcon = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    matIcon.addSvgIcon(
      'stock_shelves',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/shelves.svg'),
    );
    matIcon.addSvgIcon(
      'download',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/download.svg'),
    );
  }
}
